import script from "./home.vue?vue&type=script&setup=true&lang=ts"
export * from "./home.vue?vue&type=script&setup=true&lang=ts"

import "./home.vue?vue&type=style&index=0&id=27d4d9d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d4d9d6"]])

export default __exports__